import { render, staticRenderFns } from "./PDPDiscussionContent.vue?vue&type=template&id=1f09ea1b&scoped=true&"
import script from "./PDPDiscussionContent.vue?vue&type=script&lang=js&"
export * from "./PDPDiscussionContent.vue?vue&type=script&lang=js&"
import style0 from "./PDPDiscussionContent.vue?vue&type=style&index=0&id=1f09ea1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09ea1b",
  null
  
)

export default component.exports